import { createAsyncThunk } from '@reduxjs/toolkit';

import { TPartnerType } from '@/modules/partner/model/partnerType';
import { ThunkResult } from '@/shared/actions/thunk-result';

import { onboardingAPI } from '../api';
import { namespace } from '../namespace';

const updatePartnerType = createAsyncThunk(
  `${namespace}/update-partner-type`,
  async (type: TPartnerType): Promise<ThunkResult> => {
    await onboardingAPI.updatePartnerType(type);

    return { isSucceed: true };
  },
);

export { updatePartnerType };
